import List from 'ln/list/List';
import CustomBase from './CustomBase';
import UserFileModel from './UserFileModel';
import { backend } from '../../setup';
import { ISlide } from '../slideview/SlideDetailView';


class CustomSlrgUserSequenceModel extends CustomBase {

	constructor( json:Object ){
		super( json );	
	}

	static getInstance(){
		return new CustomSlrgUserSequenceModel({
			origin: null,
			time: 15,
			done: false,
			title: null,
			module: null,
			socialform: 'individual_work',
			content: null,
			objective: null,
			expertise: null,
			method_location: null,
			note:'',
			userfiles: new List<UserFileModel>(),
			modelName:"App\\CustomSlrgUserSequence",
		});
	}

	get src_goal():string {
		return this.get<string>( 'src_goal' );
	}

	get esa_goal():string {
		return this.get<string>( 'esa_goal' );
	}

	get note():string {
		return this.get<string>( 'note', '' );
	}
	
	set note( n:string ){
		this.set( 'note', n );	
	}
	
	get objective():string {
		return this.get<string>( 'objective' );	
	}
	
	set objective( value:string ){
		this.set( 'objective', value );	
    }
    
	get expertise():string {
		return this.get<string>( 'expertise' );	
	}
	
    set expertise( value:string ){
		this.set( 'expertise', value );	
    }
    
	get method_location():string {
		return this.get<string>( 'method_location' );	
	}
	
	set method_location( value:string ){
		this.set( 'method_location', value );	
    }
    
	get socialform():string {
		return this.get<string>( 'socialform' );	
	}
	
	set socialform( value:string ){
		this.set( 'socialform', value );	
    }
    
	get content():string {
		return this.get<string>( 'content' );	
	}
	
	set content( value:string ){
		this.set( 'content', value );	
	}

	get userfiles():List<UserFileModel>{
		return this.get<List<UserFileModel>>( 'userfiles' );
	}

	set userfiles( userfiles:List<UserFileModel> ){
		this.set( 'userfiles', userfiles );
	}

	get slides():List<ISlide>{
		return this.get<List<ISlide>>( 'slides' );
	}

	set slides( slides:List<ISlide> ){
		this.set( 'slides', slides );
	}


}

export default CustomSlrgUserSequenceModel;


backend.mapper.toModel.add( 'App\\CustomSlrgUserSequence', function( json:any ) {
		
	var sequence = new CustomSlrgUserSequenceModel( json );
	
	sequence.userfiles = new List<UserFileModel>( json.userfiles );

	return sequence;	
});

backend.mapper.toJson.add( 'App\\CustomSlrgUserSequence', function( model:CustomSlrgUserSequenceModel){
	var clone = model.object();
	clone['userfiles'] = model.userfiles ? backend.mapper.json( model.userfiles.all() ) : [];
	return clone;
});